import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteUserPayload {
    data: {
        id: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

interface IDeleteState {
    status: string
    errors: any
}

const initialState: IDeleteState = {
    status: STATUS.IDLE,
    errors: null
}

const userDeleteSlice = createSlice({
    name: 'hub/user/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteUserPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const userDeleteActions = userDeleteSlice.actions
export default userDeleteSlice.reducer
